{
  "AUDIT_LOGS": {
    "HEADER": "Dzienniki Audytu",
    "HEADER_BTN_TXT": "Dodaj Dzienniki Audytu",
    "LOADING": "Pobieranie Dzienników Audytu",
    "DESCRIPTION": "Audit Logs maintain a record of activities in your account, allowing you to track and audit your account, team, or services.",
    "LEARN_MORE": "Learn more about audit logs",
    "SEARCH_404": "Brak elementów pasujących do tego zapytania",
    "SIDEBAR_TXT": "<p><b>Dzienniki Audytu</b></p><p>Dzienniki Audytu to ślady działań i zdarzeń w systemie Chatwoot.</p>",
    "LIST": {
      "404": "Brak dostępnych Dzienników Audytu na tym koncie.",
      "TITLE": "Zarządzaj Dziennikami Audytu",
      "DESC": "Dzienniki Audytu to ślady działań i zdarzeń w systemie Chatwoot.",
      "TABLE_HEADER": {
        "ACTIVITY": "Aktywność",
        "TIME": "Akcja",
        "IP_ADDRESS": "Adres IP"
      }
    },
    "API": {
      "SUCCESS_MESSAGE": "Dzienniki Audytu pobrane pomyślnie",
      "ERROR_MESSAGE": "Nie można połączyć się z serwerem Woot, proszę spróbować później"
    },
    "DEFAULT_USER": "System",
    "AUTOMATION_RULE": {
      "ADD": "{agentName} created a new automation rule (#{id})",
      "EDIT": "{agentName} updated an automation rule (#{id})",
      "DELETE": "{agentName} deleted an automation rule (#{id})"
    },
    "ACCOUNT_USER": {
      "ADD": "{agentName} zaprosił {invitee} do konta jako {role}",
      "EDIT": {
        "SELF": "{agentName} zmienił swoje {attributes} na {values}",
        "OTHER": "{agentName} zmienił {attributes} użytkownika {user} na {values}",
        "DELETED": "{agentName} changed {attributes} of a deleted user to {values}"
      }
    },
    "INBOX": {
      "ADD": "{agentName} created a new inbox (#{id})",
      "EDIT": "{agentName} updated an inbox (#{id})",
      "DELETE": "{agentName} deleted an inbox (#{id})"
    },
    "WEBHOOK": {
      "ADD": "{agentName} created a new webhook (#{id})",
      "EDIT": "{agentName} updated a webhook (#{id})",
      "DELETE": "{agentName} deleted a webhook (#{id})"
    },
    "USER_ACTION": {
      "SIGN_IN": "{agentName} zalogował się",
      "SIGN_OUT": "{agentName} wylogował się"
    },
    "TEAM": {
      "ADD": "{agentName} created a new team (#{id})",
      "EDIT": "{agentName} updated a team (#{id})",
      "DELETE": "{agentName} deleted a team (#{id})"
    },
    "MACRO": {
      "ADD": "{agentName} created a new macro (#{id})",
      "EDIT": "{agentName} updated a macro (#{id})",
      "DELETE": "{agentName} deleted a macro (#{id})"
    },
    "INBOX_MEMBER": {
      "ADD": "{agentName} added {user} to the inbox(#{inbox_id})",
      "REMOVE": "{agentName} removed {user} from the inbox(#{inbox_id})"
    },
    "TEAM_MEMBER": {
      "ADD": "{agentName} added {user} to the team(#{team_id})",
      "REMOVE": "{agentName} removed {user} from the team(#{team_id})"
    },
    "ACCOUNT": {
      "EDIT": "{agentName} updated the account configuration (#{id})"
    },
    "CONVERSATION": {
      "DELETE": "{agentName} deleted conversation #{id}"
    }
  }
}
